<template>
  <pf-grid gutter>
    <pf-grid-item md="6" xl="4">
      <pf-title h="3" class="pf-v6-u-mb-md">{{ $t('Servizi Hosting') }}</pf-title>

      <template v-for="(v, k) in wizard.hostingPaths">
        <pf-radio
          v-if="v"
          :key="k"
          :label="v.label"
          :description="v.description"
          :name="name"
          :required="required"
          :value="k"
          :checked="k === modelValue"
          @change="emit('update:modelValue', k)"
        />
      </template>
    </pf-grid-item>

    <pf-grid-item md="6" xl="4">
      <pf-title h="3" class="pf-v6-u-mb-md">{{ $t('Servizi Cloud') }}</pf-title>

      <template v-for="(v, k) in wizard.cloudPaths">
        <pf-radio
          v-if="v"
          :key="k"
          :label="v.label"
          :description="v.description"
          :name="name"
          :required="required"
          :value="k"
          :checked="k === modelValue"
          @change="emit('update:modelValue', k)"
        />
      </template>
    </pf-grid-item>

    <pf-grid-item v-if="wizard.resellerPaths.staging" md="6" xl="4">
      <pf-title h="3" class="pf-v6-u-mb-md">{{ $t('Servizi per reseller') }}</pf-title>

      <template v-for="(v, k) in wizard.resellerPaths">
        <pf-radio
          v-if="v"
          :key="k"
          :label="v.label"
          :description="v.description"
          :name="name"
          :required="required"
          :value="k"
          :checked="k === modelValue"
          @change="emit('update:modelValue', k)"
        />
      </template>
    </pf-grid-item>
  </pf-grid>
</template>

<style scoped>
.pf-v6-l-grid.pf-m-gutter {
  --pf-v6-l-grid--m-gutter--GridGap: 3rem;
}
</style>

<script setup lang="ts">
import { useWizardQuestion, type WizardInjection } from '@/wizard';

type ValueType = WizardInjection['path'];

defineProps<{
  modelValue: ValueType;
  name: string;
  required?: boolean;
}>();

const emit = defineEmits<{
  (name: 'update:modelValue', v: ValueType): void;
}>();

const { wizard } = useWizardQuestion();
</script>
